// extracted by mini-css-extract-plugin
export var downArrow = "_6d-0";
export var infoTooltipIcon = "_6d-3";
export var label = "_6d-1";
export var optionCard = "_6d-4";
export var upArrow = "_6d-2";